import { Props } from '@components/BlockMapper';
import { ReactNode, useEffect, useMemo, useState } from 'react';
import statAPI from '@util/api/stat';
import StatBlockContent from './StatBlockContent';
import { formatStatistics } from '@util/formatStatistics';

export const StatBlock = ({ select: statBlockProps }: Props): ReactNode => {
  const [selectStatBlock, setSelectStatBlock] = useState<
    {
      title: string;
      count: string;
    }[]
  >([]);
  const statAPIInstance = new statAPI();

  useEffect(() => {
    (async () => {
      const data = await statAPIInstance.getStatsData();
      if (statBlockProps && data) {
        const filteredData = formatStatistics(statBlockProps, data);
        setSelectStatBlock(filteredData);
      }
    })();
  }, []);

  const count = useMemo(() => {
    if (selectStatBlock.length % 2) return 'odd';
    return 'even';
  }, [selectStatBlock]);

  return <StatBlockContent selectedStats={selectStatBlock} count={count} />;
};
